import { createSlice } from "@reduxjs/toolkit";

const conversationIdIdSlice = createSlice({
  name: "conversationId",
  initialState: {
    id: 0,
    convContext: null,
  },
  reducers: {
    setNewConversationID: (state, action) => {
      console.log('action.payload ', action.payload)
      state.id = action.payload.id;
      state.convContext = action.payload.convContext;
    },
  },
});

export const { setNewConversationID } = conversationIdIdSlice.actions;
export default conversationIdIdSlice.reducer 